module.exports = __webpack_public_path__ + "img/singer.97d4ade1.png";